import React from 'react'
import { Page, View, Image } from '@react-pdf/renderer'

const BudgetCover = ({ coverImage, orientation = 'portrait' }) => {
  const coverStyles = {
    page: {
      padding: 0,
      margin: 0,
    },
    imageContainer: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
    },
    coverImage: {
      width: 'auto',
      height: 'auto',
      maxWidth: '100%',
      maxHeight: '100%',
      objectFit: 'contain',
      objectPosition: 'top left',
    },
  }

  return (
    <Page size="A4" orientation={orientation} style={coverStyles.page}>
      <View style={coverStyles.imageContainer}>
        {coverImage && <Image style={coverStyles.coverImage} src={coverImage} />}
      </View>
    </Page>
  )
}

export default BudgetCover
